module.exports = __webpack_public_path__ + "img/1697740098082.7eec2bc3.jpg";